import { createContext } from 'react';
import { articleFlowerCollection } from '../budgetInvoiceModal/articleFlowerCollection';
import { OrderLine } from 'config/apiFunus/generated/data-contracts';

export const ArticleListContext = createContext<{
  infoProvidedFlowers: articleFlowerCollection,
  updateItem:(code: number, article: OrderLine) => void;
    }>(
    {
      infoProvidedFlowers: [],
      updateItem: () => false,
    });
